import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MARKET_API_BASE } from './backendConfig';

// Remove provider keys saved by older builds before any app page can access browser storage.
try {
  window.localStorage.removeItem("lwt.anthropicKey");
  window.localStorage.removeItem("lwt.geminiKey");
  window.localStorage.removeItem("lwt.aiProvider");
} catch {
  // Browser storage can be disabled in private browsing.
}

const routerBase = (process.env.REACT_APP_ROUTER_BASENAME || "").replace(/\/$/, "");
if (routerBase && window.location.pathname === "/") {
  window.location.replace(`${routerBase}/`);
}

// Render's free API sleeps after 15 minutes without inbound traffic. A lightweight
// health request every 10 minutes keeps it warm while this terminal tab is active;
// returning to a backgrounded tab also wakes it immediately. These requests are public
// and read-only; a cold service can take about a minute to answer the chart request.
const wakeMarketApi = () => {
  fetch(`${MARKET_API_BASE}/health`, { cache: "no-store", mode: "no-cors", keepalive: true }).catch(() => {});
};
wakeMarketApi();
window.setInterval(() => {
  if (document.visibilityState === "visible") wakeMarketApi();
}, 10 * 60 * 1000);
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") wakeMarketApi();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
